import { MutationTree } from "vuex";
import { CompanyState } from "./types";

export const mutations: MutationTree<CompanyState> = {};
